<!-- views/AboutCombined.vue -->
<template>
  <div class="about-combined">
    <Sidebar />
    <div class="main-content">
      <div class="header">
        <div class="navigation">
          <span class="nav-item" @click="router.push('/')">首页</span> /
          <span class="nav-item active">售后服务</span>
        </div>
        <el-button class="save-btn" type="primary" @click="saveContent">保存内容</el-button>
      </div>
      <div class="section editor-section">
        <h3>编辑内容</h3>
        <RichTextEditor v-model="aboutContent" 
        @publish="saveContent"/>
      </div>
      <div class="section preview-section">
        <h3>预览</h3>
        <div v-if="loading" class="loading">加载中...</div>
        <div v-else class="content" v-html="aboutContent"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElNotification } from 'element-plus';
import Sidebar from '../components/Sidebar.vue';
import RichTextEditor from '../components/RichTextEditor.vue';
import { getAftersale, updateAftersale } from '@/api/api';

// Reactive state
const aboutContent = ref('');
const loading = ref(false);
const router = useRouter();

// Default content as fallback
const getDefaultContent = () => `
  <p>HANDAN Langtai Chem Co., LTD. is a focus on fine chemical intermediates of science, product and trade into an organic whole of technology-based manufacturing company...</p>
`;

// Load content from API
const loadContent = async () => {
  loading.value = true;
  try {
    const response = await getAftersale();
    aboutContent.value = response.data?.content || getDefaultContent();
  } catch (error) {
    console.error('获取内容失败:', error);
    ElNotification({
      title: '错误',
      message: '加载内容失败，请刷新重试',
      type: 'error',
    });
    aboutContent.value = getDefaultContent();
  } finally {
    loading.value = false;
  }
};

// Save content to API
const saveContent = async () => {
  try {
    await updateAftersale({ content: aboutContent.value });
    ElNotification({
      title: '成功',
      message: '内容已保存！',
      type: 'success',
    });
    await loadContent(); // Reload to confirm save
  } catch (error) {
    console.error('保存失败:', error);
    ElNotification({
      title: '错误',
      message: '保存失败，请稍后重试',
      type: 'error',
    });
  }
};

// Fetch content on mount
onMounted(loadContent);
</script>

<style scoped>
.about-combined {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding: 30px;
  margin-left: 200px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 15px 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.navigation {
  display: flex;
  gap: 8px;
  font-size: 16px;
}

.nav-item {
  cursor: pointer;
  color: #555;
  transition: color 0.3s ease;
}

.nav-item.active {
  color: #5a9bd4;
  font-weight: 600;
}

.nav-item:hover {
  color: #5a9bd4;
  text-decoration: underline;
}

.save-btn {
  padding: 10px 20px;
}

.section {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.editor-section h3,
.preview-section h3 {
  margin-bottom: 15px;
  font-size: 18px;
  color: #333;
}

.content {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
}

.content img {
  max-width: 100%;
  height: auto;
  margin: 10px 0;
}

.loading {
  text-align: center;
  font-size: 16px;
  color: #555;
}
</style>